import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_WEB_LIVE_NOT_SUPPORTED_BODY]:
    'Watch Live using the HTML5 player in Internet Explorer 11, on Windows 8.1 or later, Microsoft Edge on Windows 10, Chrome, Firefox and Opera.',
}
